/**
 * DG Consigne Automation v2
 * Fonctionne sur TOUTES les pages (global).
 * Détecte les produits consignés via /products/{handle}.js (tags réels).
 * Synchronise la quantité du produit CONSIGNE automatiquement.
 */
(function () {
    'use strict';

    var META = window.DG_CONSIGNE_META || { variantId: 0, sku: 'DG1', tag: 'Consigné' };
    var CONSIGNE_SKU   = META.sku;
    var CONSIGNE_TAG   = META.tag;
    var CONSIGNE_VID   = META.variantId;

    var CART_JS        = '/cart.js';
    var CART_ADD_JS    = '/cart/add.js';
    var CART_CHANGE_JS = '/cart/change.js';

    /* Cache mémoire des tags produit pour éviter des appels répétés */
    var _tagCache = {};  // handle → true/false (est-ce consigné ?)
    var _syncing  = false;  /* sync en cours (vérif tags ou apply) */
    var _applying = false;  /* fetch cart/add|change consigne — locke les boutons qty */
    var _ownCall  = false;  // true pendant nos propres fetch /cart/add ou /cart/change
    var _lastAfterSyncTime = 0;  // timestamp du dernier afterSync (anti-boucle)
    var _syncDebounce = null;    // timer pour le listener dg:cart:updated
    var _needsCheck = true;
    var _checkError = false;

    function scheduleCheck() {
        clearTimeout(_syncDebounce);
        _syncDebounce = setTimeout(syncConsigne, 0);
    }
    function failCheck() {
        _checkError = true;
        _needsCheck = true;
        _syncing = false;
        if (window.DGCart) window.DGCart.showError('La consigne n’a pas pu être vérifiée. Rechargez la page avant de passer à la caisse.');
    }

    /* ── Extraire le nombre d'unités par item depuis le variant_title ──
     * Supporte les formats multi-facteurs : "Caisse 6×4×250ML" → 24, "Caisse 24×250ML" → 24
     * "Caisse 6×330ML" → 6, "Unité 1UN" → 1, "Pack 12x" → 12
     *
     * Stratégie :
     *   1. Trouver tous les segments numériques "NxN" avant l'unité de volume (mL/ML/L/G/KG)
     *   2. Multiplier ces facteurs entre eux
     *   Ex: "6×4×250ML" → facteurs avant ML = [6, 4] → 6*4 = 24
     *   Ex: "24×250ML"  → facteurs avant ML = [24]   → 24
     *   Ex: "6×330ML"   → facteurs avant ML = [6]    → 6
     *   Ex: "1UN"       → aucun facteur trouvé        → 1
     */
    function getUnitsPerItem(item) {
        var title = (item.variant_title || item.title || '');

        // Chercher le patron NxNxVOLUME_UNIT n'importe où dans le titre
        // Ex: "Caisse 6x4x250ML" → match "6x4x250ML", extraire [6, 4] → 24
        // Ex: "Caisse 24x250ML"  → match "24x250ML",  extraire [24]   → 24
        // Ex: "Caisse 6x330ML"   → match "6x330ML",   extraire [6]    → 6
        // Ex: "Unité 1UN"        → aucun match → 1
        var volumeMatch = title.match(/((?:\d+\s*[x×X]\s*)+)\d+\s*(?:ml|mL|ML|cl|CL|g\b|G\b|kg|KG|L\b|oz|OZ)/i);
        if (volumeMatch) {
            // La portion capturée est "6x4x" ou "24x" ou "6x" — extraire tous les entiers
            var parts = volumeMatch[1].match(/\d+/g);
            if (parts && parts.length > 0) {
                return parts.reduce(function(acc, n) { return acc * parseInt(n, 10); }, 1);
            }
        }

        // Fallback : chercher le premier pattern simple NUMBERx (ex: "Caisse 24x" ou "Pack 12x")
        var simpleMatch = title.match(/(\d+)\s*[x×X]/i);
        if (simpleMatch) return parseInt(simpleMatch[1], 10);

        return 1;
    }

    /* ── Savoir si un produit (par handle) a le tag Consigné ── */
    function isConsigne(handle, cb) {
        if (handle === 'consigne-0-10' || handle === 'consigne') { return cb(false); }
        if (_tagCache[handle] !== undefined) { return cb(_tagCache[handle]); }

        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 20000);
        fetch('/products/' + handle + '.js', { signal: controller.signal, cache: 'no-store' })
            .then(function (r) { if (!r.ok) throw new Error('Produit inaccessible'); return r.json(); })
            .then(function (p) {
                if (!p || !(Array.isArray(p.tags) || typeof p.tags === 'string')) throw new Error('Réponse produit incomplète');
                var tags = (p && p.tags) ? p.tags : [];
                // tags est un Array ou une string selon la version
                var tagsArr = Array.isArray(tags) ? tags : String(tags).split(',').map(function(t){return t.trim();});
                var isC = tagsArr.indexOf(CONSIGNE_TAG) !== -1;
                _tagCache[handle] = isC;
                cb(isC);
            })
            .catch(function () {
                cb(null); // a failed product read cannot prove that a deposit is not required
            }).finally(function () { clearTimeout(timeout); });
    }

    /* ── Sync principale ── */
    function syncConsigne() {
        if (_syncing || _checkError) return;
        if (window.DGCart && window.DGCart.isPending()) {
            window.DGCart.whenIdle().then(syncConsigne);
            return;
        }
        if (!CONSIGNE_VID) {
            console.warn('[dgConsigne] Pas de variantId — vérifier all_products[\'consigne-0-10\'] dans theme.liquid');
            failCheck();
            return;
        }
        _syncing = true;
        /* NOTE: on ne dispatche PAS syncStart ici.
           On le fait uniquement si un vrai changement consigne est nécessaire,
           pour ne pas locker les boutons inutilement (items sans consigne). */

        var revision = window.DGCart ? window.DGCart.version() : 0;
        function outdated() {
            if (window.DGCart && (window.DGCart.version() !== revision || window.DGCart.isPending())) {
                _syncing = false;
                _needsCheck = true;
                scheduleCheck();
                return true;
            }
            return false;
        }
        (window.DGCart ? window.DGCart.read() : fetch(CART_JS).then(function (r) { if (!r.ok) throw new Error('Panier inaccessible'); return r.json(); }))
            .then(function (cart) {
                if (outdated()) return;
                /* Trouver la ligne consigne actuelle */
                var consigneLine = null;
                var regularItems = [];

                cart.items.forEach(function (item) {
                    if (item.sku === CONSIGNE_SKU) {
                        consigneLine = item;
                    } else {
                        regularItems.push(item);
                    }
                });

                if (regularItems.length === 0) {
                    /* Panier vide (hors consigne) → supprimer la consigne si présente */
                    if (consigneLine) {
                        applyConsigne(consigneLine.key, 0);
                    } else {
                        _syncing = false;
                        _needsCheck = false;
                        if (window.DGCart) window.DGCart.clearPendingMessage();
                        /* Pas de changement → pas de syncStart → pas besoin de syncEnd */
                    }
                    return;
                }

                /* Vérifier les tags en parallèle pour chaque item régulier */
                var pending = regularItems.length;
                var consignéQty = 0;

                regularItems.forEach(function (item) {
                    isConsigne(item.handle, function (ok) {
                        if (_checkError) return;
                        if (ok === null) { failCheck(); return; }
                        if (ok) consignéQty += item.quantity * getUnitsPerItem(item);
                        pending--;
                        if (pending === 0) {
                            if (outdated()) return;
                            /* Toutes les vérifications sont terminées */
                            var currentQty = consigneLine ? consigneLine.quantity : 0;
                            var currentKey = consigneLine ? consigneLine.key : null;

                            if (consignéQty === currentQty) {
                                /* Rien à changer → sortir sans locker les boutons */
                                _syncing = false;
                                _needsCheck = false;
                                if (window.DGCart) window.DGCart.clearPendingMessage();
                                return;
                            }

                            if (consignéQty === 0) {
                                /* Supprimer */
                                if (currentKey) applyConsigne(currentKey, 0);
                                else { _syncing = false; _needsCheck = false; if (window.DGCart) window.DGCart.clearPendingMessage(); }
                            } else if (currentQty === 0) {
                                /* Ajouter */
                                addConsigne(consignéQty);
                            } else {
                                /* Mettre à jour */
                                applyConsigne(currentKey, consignéQty);
                            }
                        }
                    });
                });
            })
            .catch(function (err) {
                console.error('[dgConsigne] Erreur fetch cart:', err);
                failCheck();
            });
    }


    function beginConsigneApply() {
        _applying = true;
        document.dispatchEvent(new CustomEvent('dg:consigne:syncStart'));
    }

    function endConsigneApply() {
        _applying = false;
        document.dispatchEvent(new CustomEvent('dg:consigne:syncEnd'));
    }

    function addConsigne(qty) {
        beginConsigneApply();
        _ownCall = true;
        var updates = {};
        updates[String(CONSIGNE_VID)] = qty;
        // Absolute quantity is safe when two tabs both discover a missing deposit line.
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
        })
        .then(function (r) { if (!r.ok) throw new Error('Consigne refusée'); _ownCall = false; afterSync(); })
        .catch(function (err) {
            console.error('[dgConsigne] Erreur add:', err);
            _ownCall = false;
            failCheck();
            endConsigneApply();
        });
    }

    function applyConsigne(key, qty) {
        beginConsigneApply();
        _ownCall = true;
        fetch(CART_CHANGE_JS, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(function (r) { if (!r.ok) throw new Error('Consigne refusée'); _ownCall = false; afterSync(); })
        .catch(function (err) {
            console.error('[dgConsigne] Erreur change:', err);
            _ownCall = false;
            failCheck();
            endConsigneApply();
        });
    }

    function afterSync() {
        _lastAfterSyncTime = Date.now();
        _syncing = false;
        endConsigneApply();
        _needsCheck = true;
        scheduleCheck();

        if (window.location.pathname === '/cart') {
            /* Sur la page panier : mettre à jour les items + totaux via Shopify Sections API.
               Pas de reload = scroll préservé, pas de clignotement, aucune boucle. */
            refreshCartSection();
        } else {
            /* Sur les autres pages : mettre à jour le drawer, le badge et les cartes produits */
            if (typeof window.refreshCartState === 'function') {
                window.refreshCartState();
            }
        }
    }

    /* ── Refresh partiel de la page panier via Shopify Sections API ──
       Remplace uniquement #dg-cart-items et .dg-cart-totals (pas le widget Zapiet / livraison).
       Utilise document.addEventListener délégué → les event listeners survivent au DOM swap. */
    function refreshCartSection() {
        var revision = window.DGCart ? window.DGCart.version() : 0;
        fetch('/?sections=main-cart-dg')
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (window.DGCart && (window.DGCart.version() !== revision || window.DGCart.isPending())) {
                    window.DGCart.whenIdle().then(refreshCartSection);
                    return;
                }
                var html = data['main-cart-dg'];
                if (!html) return;

                var parser  = new DOMParser();
                var doc     = parser.parseFromString(html, 'text/html');

                /* Sauvegarder la position de scroll de la fenêtre */
                var savedScrollY = window.scrollY;

                /* ── 1. Items list ── */
                var currentItems = document.getElementById('dg-cart-items');
                var newItems     = doc.getElementById('dg-cart-items');
                if (currentItems && newItems) {
                    currentItems.innerHTML = newItems.innerHTML;
                }

                /* ── 2. Totaux (sous-total, taxes, consigne, total) ── */
                var currentTotals = document.querySelector('.dg-cart-totals');
                var newTotals     = doc.querySelector('.dg-cart-totals');
                if (currentTotals && newTotals) {
                    currentTotals.outerHTML = newTotals.outerHTML;
                }

                /* ── 3. Compteur d'articles dans le header ── */
                var currentCount = document.querySelector('.dg-cart__count');
                var newCount     = doc.querySelector('.dg-cart__count');
                if (currentCount && newCount) {
                    currentCount.textContent = newCount.textContent;
                }

                /* ── 4. Restaurer le scroll (requestAnimationFrame pour attendre le paint) ── */
                requestAnimationFrame(function () {
                    window.scrollTo(0, savedScrollY);
                });

                /* ── 5. Mettre à jour aussi le header badge et le drawer ── */
                if (typeof window.refreshCartState === 'function') {
                    window.refreshCartState();
                }
            })
            .catch(function (err) {
                console.error('[dgConsigne] Erreur refreshCartSection:', err);
                /* Fallback seulement si la Sections API échoue */
                if (window.DGCart) window.DGCart.showError('Le panier n’a pas pu être actualisé. Rechargez la page pour vérifier vos articles.');
            });
    }


    /* ── Écoute des événements cart ──
       DÉCLENCHEUR 1 : patchFetch (ci-dessous) — intercepte /cart/add et /cart/change natifs.
       DÉCLENCHEUR 2 : dg:cart:updated — fallback pour les changements de qty dans le drawer.

       Anti-boucle : _lastAfterSyncTime empêche de re-déclencher dans les 2s qui suivent
       notre propre afterSync (ex: afterSync → refreshCartState → dg:cart:updated → skip).
    */
    document.addEventListener('dg:cart:updated', function (ev) {
        /* Ignorer si c'est notre propre afterSync qui a déclenché le refresh */
        if (Date.now() - _lastAfterSyncTime < 2000) return;
        /* Ignorer si un sync est déjà en cours */
        if (_syncing) return;
        /* Page panier : laisser le debounce qty finir avant consigne (évite refresh section en rafale) */
        var delay = (ev && ev.detail && ev.detail.source === 'dg-cart-page') ? 1100 : 700;
        clearTimeout(_syncDebounce);
        _syncDebounce = setTimeout(syncConsigne, delay);
    });
    document.addEventListener('dg:cart:pending', function () { _needsCheck = true; });
    document.addEventListener('dg:cart:settled', function () { _needsCheck = true; scheduleCheck(); });

    /* 2. Intercepter les appels /cart/add.js natifs (ajout rapide PDP, quick-view) */
    (function patchFetch() {
        var origFetch = window.fetch;
        window.fetch = function (input, init) {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var result = origFetch.apply(this, arguments);
            /* Ignorer nos propres appels internes pour éviter la boucle infinie */
            if (!_ownCall && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1)) {
                result.then(function () {
                    if (window.location.pathname.indexOf('/cart') !== -1) return;
                    setTimeout(syncConsigne, 500);
                }).catch(function () {});
            }
            return result;
        };
    })();

    /* ── Init ── */
    function init() {
        syncConsigne();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.dgConsigne = {
        sync: syncConsigne,
        clearCache: function () { _tagCache = {}; _checkError = false; _needsCheck = true; },
        isPending: function () { return _needsCheck || _syncing || _applying; },
        hasError: function () { return _checkError; },
        /* Ne bloquer les +/- que pendant un vrai cart/change consigne, pas pendant la vérif des tags */
        isSyncing: function () { return _applying; }
    };

})();
